import _objectSpread from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import React from 'react';
/**
 * @typedef { object } CommunicationBasicModel Data model returned by the sever representing a communication job.
 * @property { string } JobName Job name
 * @property { string } Id Job identifier
 * @property { string } Communication Project name
 * @property { string } Author Job author
 * @property { string } Stage Job stage (Aborted | Processing | FinishedWithErrors | FinishedOK | Starting | WaitingForInput | WaitingForTask | WaitingForSignature)
 * @property { string } Workspace Project workspace.
 * @property { string } LastModified Last modified date.
 **/

/** @type {import('../types').DataType<CommunicationBasicModel>} */

var COMMUNICATION_RUN_DATA_TYPE = {
  data: {
    itemUrl: '/backend/jobsummary?id={id}',
    dataKey: 'communicationRun',
    idKeyProp: 'Id',
    onBeforeRequest: function onBeforeRequest(options, request) {
      if (request.type === 'loadItem' && options.dataProps) {
        return _objectSpread({}, request, {
          query: _objectSpread({}, request.query, {
            workspace: options.dataProps.workspace
          })
        });
      }

      return request;
    }
  }
};
export default COMMUNICATION_RUN_DATA_TYPE;